module.exports = "/images/menu-account.svg?8593f0ceba37555ffa27bc3b7aa01d41";